/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles from './styles'

const FormLabel = ({ htmlFor, label, optional, className, id, forwardRef, onClick }) => (
  <label ref={forwardRef} htmlFor={htmlFor} className={cx(styles.label, className)} onClick={onClick} id={id}>
    {label}
    {Boolean(optional) && <> (optional)</>}
  </label>
)

FormLabel.propTypes = {
  htmlFor: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  optional: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  forwardRef: PropTypes.any,
  onClick: PropTypes.func,
}

export default FormLabel
